import request from 'utils/request_ajax';
import {
  removeAuthTokenFromLocalStorage,
  replaceCAToken,
} from './centralAuthToken';

const silentCALogout = async () => {
  try {
    await request.get('/signout', { no_redirection: true });
    return 'success';
  } catch {
    return 'failed';
  }
};

window.addEventListener('message', async event => {
  if (
    !event.origin.endsWith('seismic.com') &&
    !event.origin.endsWith('seismic-dev.com')
  ) {
    return;
  }

  // ignore browser extensions that are sending messages.
  if (window === event.source) {
    return;
  }

  if (event.data?.domain?.includes('seismic')) {
    let result;

    // replace access token
    if (event.data?.msgKey === 'renew_token' && event.data?.accessToken) {
      result = await replaceCAToken(event.data?.accessToken);
    } else if (event.data?.msgKey === 'logout') {
      // logout
      result = await silentCALogout();
      removeAuthTokenFromLocalStorage();
    }

    if (result !== undefined) {
      event.source.postMessage({ result }, event.origin);
    }
  }
});
